import { useRollbar } from "@rollbar/react";
import { PostIntentResponse } from "./Types";
import { getCountry } from "./getCountry";

/** For debugging DFClient response */
export const useDebugHelper = () => {
	const rollbar = useRollbar();

	const debugHelper = (response: PostIntentResponse, leadId: string | null) => {
		// the country attribute as saved on the consumer consent object
		const countryConsumerAttribute =
			response.data.parameters.vic?.consent?.collectPII?.consumer?.attributes
				?.country;

		// the country attribute as saved on the df session
		const countrySessionAttribute = response.data.parameters.country;

		const countryDetected = getCountry();

		const debug = {
			intent: response.data.Query.Text,
			intentDetection: response.data.intent_detection_confidence,
			hostname: window.location.hostname,
			countryConsumerAttribute,
			countrySessionAttribute,
			countryDetected,
			sessionKeys: Object.keys(response.data.parameters),
		};

		if (!countryConsumerAttribute) {
			rollbar.error(
				`[DFCLIENT RESPONSE] ${leadId}: country code missing`,
				debug
			);
		} else if (countryDetected !== countryConsumerAttribute) {
			rollbar.error(
				`[DFCLIENT RESPONSE] ${leadId}: country code mismatch`,
				debug
			);
		} else {
			rollbar.info(`[DFCLIENT RESPONSE] ${leadId}`, debug);
		}
	};

	return debugHelper;
};
